import React from 'react';
import Navbar from '../components/Navbar';
import ServiceCard from '../components/ServiceCard';

// Import icons or images for each service
import CustomSoftwareIcon from '../assets/custom-software-icon.png';
import CloudSecurityIcon from '../assets/cloud-security-icon.png';
import AIThreatIntelligenceIcon from '../assets/ai-threat-intelligence-icon.png';

function Services() {
  const services = [
    {
      title: 'GenAI & Agentic Systems Architecture',
      description: 'Design and deploy fully autonomous agent-based systems that plan, build, test, and deploy real software—without traditional dev teams. From AI-first workflows to orchestrated code generation, we implement modern agentic patterns across cloud-native stacks.',
      icon: AIThreatIntelligenceIcon,
    },
    {
      title: 'LLM-Powered Infrastructure Automation',
      description: 'Build self-operating platforms using language models as system-level agents. We specialize in embedding LLMs into CI/CD, cloud provisioning, and infrastructure-as-code pipelines, making your entire environment intelligent and adaptive.',
      icon: CloudSecurityIcon,
    },
    {
      title: 'Autonomous Software Delivery Teams',
      description: 'We replace human-heavy dev teams with AI crews: coordinated agents that plan features, write code, run QA, and deploy. This enables rapid iteration, extreme scalability, and drastically reduced time-to-market.',
      icon: CustomSoftwareIcon,
    },
  ];

  return (
    <div>
      <Navbar />
      <main className="services-section">
        <h1>Our Services</h1>
        <p>
          At Cloud Rhino, we are at the forefront of leveraging Artificial Intelligence to transform software development and infrastructure management. Our expertise in GenAI, LLMs, and autonomous systems allows us to deliver solutions that dramatically increase efficiency, scalability, and speed.
        </p>
        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              title={service.title}
              description={service.description}
              icon={service.icon}
            />
          ))}
        </div>
        <p className="cta-text">
          Ready to transform your software delivery and infrastructure with AI? <a href="/contact">Contact us today</a> to learn more.
        </p>
      </main>
    </div>
  );
}

export default Services;
